import React, { useState, useEffect } from "react";
import { SectionWrapper } from "./FooterStyle.styled.js";
import { setStateSurveyConfiguration } from "../../helpers/StateSurveyConfiguration";
import { Form } from "react-bootstrap";
import { IconMandatory } from "../SurveyConfigurationForm/SurveyConfiguration.styled";
import EditorConvertToMarkdown from "../EditorConvertToMarkdown";

const FooterStyle = ({ footerText = "" }) => {
  const [footerTxt, setFooterTxt] = useState(footerText);

  useEffect(() => {
    footerHandler();
  }, [footerTxt]);

  let footerHandler = () => {
    setStateSurveyConfiguration(footerTxt, "Footer");
  };

  return (
    <>
      <br />
      <SectionWrapper>
        <Form.Label>
          <IconMandatory>*</IconMandatory>Footer text
        </Form.Label>
        <EditorConvertToMarkdown
          editor={footerTxt}
          setEditor={setFooterTxt}
          style={{ width: "100%" }}
        />
      </SectionWrapper>
    </>
  );
};

export default FooterStyle;
